import React, { useState } from 'react';
import { uniqueId } from 'lodash';

import Tooltip from 'components/Tooltip';

import { ButtonBase } from './styles';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color?:
    | 'default'
    | 'primary'
    | 'font'
    | 'success'
    | 'warn'
    | 'danger'
    | 'secondary'
    | 'flag';
  size?: 'sm' | 'lg' | 'xsm';
  fill?: boolean;
  round?: boolean;
  border?: boolean;
  tooltip?: string;
  tooltipPosition?: 'bottom' | 'left' | 'right' | 'top';
  href?: string;
}

const Button: React.FC<IProps> = ({
  children,
  color = 'primary',
  fill = false,
  round = false,
  border = false,
  tooltipPosition = 'bottom',
  tooltip,
  href,
  ...rest
}: IProps) => {
  const [id] = useState(uniqueId(new Date().getTime().toString()));

  const buttonContent = (
    <ButtonBase
      id={`id_button_tooltip_${id}`}
      color={color}
      $fill={fill}
      $round={round}
      $border={border}
      {...rest}
    >
      {children}
    </ButtonBase>
  );

  return (
    <>
      {href ? (
        <a href={href} style={{ textDecoration: 'none' }}>
          {buttonContent}
        </a>
      ) : (
        buttonContent
      )}

      {tooltip && (
        <Tooltip target={`id_button_tooltip_${id}`} position={tooltipPosition}>
          {tooltip}
        </Tooltip>
      )}
    </>
  );
};
export default Button;
